import { BrowserRouter, Route, Switch } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import PageNotFound from './Pages/404/error'
import Home from './Pages/Home/home'
import Dashboard from './Pages/Dashboard/dashboard'
import Locker from './Pages/Locker/lockLiquidity'
import DetailedPage from './Pages/Locker/DetailedPage/detailedPage'
import LPLockPage from './Pages/Locker/LPLockPage/lpLock'
import WithdrawPage from './Pages/Locker/withdrawPage/withdrawPage'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/dashboard" component={Dashboard} />
          {/* <Route path="/sdfsdfsdf" component={Locker} />
          <Route path="/afdfsdf" component={LPLockPage} />
          <Route path="/wetfdsb" component={DetailedPage} />
          <Route path="/ghmjghgf" component={WithdrawPage} /> */}
          <Route path="/locker" component={Locker} />
          <Route path="/lp-lock" component={LPLockPage} />
          <Route path="/lp-details" component={DetailedPage} />
          <Route path="/lp-Withdraw" component={WithdrawPage} />
          <Route component={PageNotFound} />
        </Switch>
        {/* <Home  />
        <Dashboard /> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
